import React from 'react';

const AllReviews = () => {
    return (
        <div>
            
        </div>
    );
};

export default AllReviews;